$incdec-background1:'#182A38' !default;
$incdec-background2:'#2A475B' !default;
$incdec-color:'#A7BED1' !default;
$incdec-icon-text-stroke:'#243e50' !default;

@mixin button-style {
  button {
    background: linear-gradient( 0deg,#{$incdec-background1}, #{$incdec-background2});
    .fa{
      color:white;
      -webkit-text-stroke:2px #{$incdec-icon-text-stroke};
    }
  }
  .btn:active{
    background: linear-gradient( 0deg,#{$incdec-background1}, #{$incdec-background2});
  }
}

@mixin center-col-style{
  background: linear-gradient( 0deg,#{$incdec-background1}, #{$incdec-background2});
  color: #{$incdec-color};
}

.left-col {
  @include button-style;
}

.right-col {
  @include button-style;
}

.center-col {
  @include center-col-style;

  input{
    background-color: transparent;
    color: #{$incdec-color};
  }
}




// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-prod-baristadj-server/src/app/components/incdec/incdec-theme.scss